import { rewriteUserContactEmail } from '@uplift/api';
import { EMAIL_MATCHES, EMPTY_STRING } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { useUpdateSettingsHandlers } from '@uplift/ui-v2';

import * as Yup from 'yup';
import { SettingsData } from '../../../hooks/use-settings-data.hook';

export type ClientFacingEmailFormType = {
  clientFacingEmail: string;
};
export const useClientFacingEmailForm = (userId: string, data: SettingsData) => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettingsHandlers(userId, l10n.providerSettings.clientFacingEmail);

  const clientFacingEmailFormik = () => {
    const initialValues: ClientFacingEmailFormType = {
      clientFacingEmail: data.contacts.clientFacingEmail || EMPTY_STRING,
    };

    const validationSchema = Yup.object({
      clientFacingEmail: Yup.string()
        .email(l10n.validations.invalidEmail)
        .matches(EMAIL_MATCHES, l10n.validations.invalidEmail)
        .required(l10n.validations.clientFacingEmailRequired),
    });

    const onSubmit = async (values: ClientFacingEmailFormType) => {
      try {
        await rewriteUserContactEmail(userId, { email: values.clientFacingEmail });

        await onFormSubmitSuccess(true);
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { clientFacingEmailFormik };
};
